import { render, staticRenderFns } from "./IndexCaseStudy.vue?vue&type=template&id=4ca727e2"
import script from "./IndexCaseStudy.vue?vue&type=script&lang=js"
export * from "./IndexCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./IndexCaseStudy.vue?vue&type=style&index=0&id=4ca727e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports